(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "prop-types", "classnames", "../hooks/useActive", "./ViewComponents/ViewComponent", "./useViewScrollRestoration", "./constants", "react/jsx-runtime"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("prop-types"), require("classnames"), require("../hooks/useActive"), require("./ViewComponents/ViewComponent"), require("./useViewScrollRestoration"), require("./constants"), require("react/jsx-runtime"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.propTypes, global.classnames, global.useActive, global.ViewComponent, global.useViewScrollRestoration, global.constants, global.jsxRuntime);
    global.View = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _propTypes, _classnames2, _useActive, _ViewComponent, _useViewScrollRestoration, _constants, _jsxRuntime) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.View = _exports.config = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames2 = _interopRequireDefault(_classnames2);
  var _excluded = ["component"];

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  var config = {
    component: _ViewComponent.ViewComponent
  };
  _exports.config = config;
  var View = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, refParent) {
    var _ref$component = _ref.component,
        Component = _ref$component === void 0 ? config.component : _ref$component,
        props = _objectWithoutProperties(_ref, _excluded);

    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        _useContext$transitio = _useContext.transitionProps,
        $duration = _useContext$transitio.duration,
        $delay = _useContext$transitio.delay,
        $timeout = _useContext$transitio.timeout;

    var active = (0, _useActive.useActive)();
    var history = (0, _reactRouter.useHistory)();
    var refSelf = (0, _react.useRef)();
    var ref = refParent || refSelf;
    (0, _useViewScrollRestoration.useViewScrollRestoration)(ref);
    var viewType = (0, _react.useMemo)(function () {
      var type = history._viewType || props.type || _constants.RTL;
      if (active && history._viewType) delete history._viewType;
      return type;
    }, [active, props.type, history]);
    var className = (0, _react.useMemo)(function () {
      return (0, _classnames2.default)(viewType, props.className, _defineProperty({}, _constants.ACTIVE, active));
    }, [props, viewType, active]);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      ref: ref,
      className: className,
      duration: $duration || $timeout,
      delay: $delay,
      viewType: viewType,
      children: props.children
    });
  });
  _exports.View = View;
  View.propTypes = {
    children: _propTypes.default.any,
    component: _propTypes.default.node,
    className: _propTypes.default.string,
    type: _propTypes.default.string
  };
});